import { Product } from '../types'

export const PRODUCTS: Product[] = [
  {
    title: 'PDPA Pro',
    id: 'pdpa-pro',
    logo: '/images/Landing/our-products/logo-pdpa-pro.svg',
    image: '/images/Landing/our-products/pdpa-pro.png',
    logoWidth: 296,
    logoHeight: 70,
    imageAspectRatio: 636 / 480,
    primaryColor: '#1b2938',
    secondaryColor: '#EEF2F6',
    paragraph:
      'สร้างนโยบายความเป็นส่วนตัว (Privacy Policy) สอดคล้องกับ PDPA เพื่อแจ้งเจ้าของข้อมูลส่วนบุคคลได้ง่าย ๆ มีให้เลือกหลากหลายนโยบาย',
    checkList: [
      'เราโฮสต์ Policy ให้คุณ ฟรี!',
      'ได้ทั้งภาษาไทยและภาษาอังกฤษ',
      'สอดคล้องกับธุรกิจของคุณ',
    ],
    href: 'https://pdpa.pro',
  },
  {
    title: 'Cookie Wow',
    id: 'cookie-wow',
    logo: '/images/Landing/our-products/logo-cookie-wow.svg',
    image: '/images/Landing/our-products/cookie-wow.png',
    logoWidth: 317,
    logoHeight: 70,
    imageAspectRatio: 636 / 440,
    primaryColor: '#ea834f',
    secondaryColor: '#FDF3EE',
    paragraph:
      'สร้างแบนเนอร์คุกกี้เพื่อขอความยินยอมจากผู้ใช้งานเว็บไซต์ในการใช้คุกกี้ในไม่ถึง <strong>2 นาที</strong> มาพร้อมกับระบบสแกนคุกกี้โดยอัตโนมัติ และระบบบันทึกการให้ความยินยอมในที่เดียว',
    checkList: [
      'สแกนคุกกี้อัตโนมัติ',
      'บล็อกคุกกี้อัตโนมัติจนกว่าจะได้รับความยินยอม',
      'บันทึกความยินยอมอัตโนมัติ',
    ],
    href: 'https://cookiewow.com',
  },
  {
    title: 'PDPA Form',
    id: 'pdpa-form',
    logo: '/images/Landing/our-products/logo-pdpa-form.svg',
    image: '/images/Landing/our-products/pdpa-form.png',
    logoWidth: 300,
    logoHeight: 70,
    imageAspectRatio: 636 / 440,
    primaryColor: '#2879f9',
    secondaryColor: '#EAF1FD',
    paragraph:
      'สร้างแบบฟอร์มพร้อมจัดการและติดตามคำร้องขอจัดการข้อมูลจากเจ้าของข้อมูลเช่น ลบ แก้ไขหรือหยุดใช้ข้อมูล ฯลฯ ตาม PDPA ภายในเวลาไม่กี่นาที พร้อมระบบแจ้งเตือนและนับถอยหลัง ให้สามารถจัดการคำร้องทั้งหมดได้ทันเวลา ไม่พลาด ไม่โดนปรับ',
    checkList: [
      'สร้างแบบฟอร์มรับคำร้องจากเจ้าของข้อมูล',
      'ติดตามสถานะคำร้องผ่านแพลตฟอร์ม',
      'แจ้งเตือนเวลาครบกำหนดอัตโนมัติ',
    ],
    href: 'https://pdpaform.com',
  },
  {
    title: 'PDPA Prokit',
    id: 'pdpa-prokit',
    logo: '/images/Landing/our-products/logo-pdpa-prokit.svg',
    image: '/images/Landing/our-products/pdpa-prokit.png',
    logoWidth: 180,
    logoHeight: 100,
    imageAspectRatio: 636 / 440,
    primaryColor: '#cca068',
    secondaryColor: '#F5ECE1',
    paragraph:
      'เอกสารมากกว่า 60+ รายการ ที่ประกอบด้วยนโยบาย ขั้นตอน กระบวนการ เครื่องมือ และเอกสารอื่น ๆ ที่คุณต้องการ เพื่อให้ปฏิบัติตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคลได้อย่างถูกต้องครบถ้วน โดยผู้เชี่ยวชาญด้านกฎหมายที่ได้รับการรับรอง',
    checkList: [
      'เอกสารแนะแนวทางในการปฏิบัติตาม PDPA',
      'นโยบายและประกาศความเป็นส่วนตัว',
      'เครื่องมือประเมินความเสี่ยง',
    ],
    href: 'https://pdpa.pro/prokit',
  },
  {
    title: 'LearnPDPA',
    id: 'learn-pdpa',
    logo: '/images/Landing/our-products/logo-learn-pdpa.svg',
    image: '/images/Landing/our-products/learn-pdpa.png',
    logoWidth: 365,
    logoHeight: 70,
    imageAspectRatio: 636 / 440,
    primaryColor: '#104ebc',
    secondaryColor: '#EAF1FD',
    paragraph:
      'คอร์สออนไลน์ที่ช่วยให้องค์กรเตรียมพร้อมรับการใช้บังคับ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล ด้วยบทเรียนที่ครบถ้วนจากผู้เชี่ยวชาญ ด้านกฎหมายที่ผ่านการรับรอง',
    checkList: [
      'ครอบคลุมทุกหัวข้อเกี่ยวกับ PDPA',
      'เข้าถึงบทเรียนได้ 24 ชั่วโมง',
      'มีแบบทดสอบหลังเรียน',
    ],
    href: 'https://learnpdpa.com',
  },
  {
    title: 'PDPA Core',
    id: 'pdpa-core',
    logo: '/images/Landing/our-products/logo-pdpa-core.svg',
    image: '/images/Landing/our-products/pdpa-core.png',
    logoWidth: 348,
    logoHeight: 51,
    imageAspectRatio: 720 / 500,
    primaryColor: '#469eff',
    secondaryColor: '#eaf1fd',
    paragraph:
      'บริการให้คำปรึกษาและดำเนินการให้ธุรกิจของคุณ สอดคล้องกับ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล โดยทีมนักกฎหมายผู้เชี่ยวชาญ พร้อมเทคโนโลยีครบครัน',
    checkList: [
      'จัดทำ Gap Analysis พร้อมคำแนะนำ รวมถึงเอกสารทางกฎหมายที่จำเป็นกับธุรกิจของคุณ',
      'ปรึกษา PDPA กับนักกฎหมายผู้เชี่ยวชาญ',
      'จัดอบรม PDPA ภายในองค์กรเพื่อให้ความรู้ ความเข้าใจกับพนักงานของคุณ',
    ],
    href: 'https://pdpacore.com',
  },
]
